// pages/Services.jsx
import React from "react";
import ServiceCategoryCard from "../components/ServiceCategoryCard";
import CTA from "../components/CTA";
import {
  serviceCategories,
  heroStats,
  heroContent,
} from "../data/servicesData";
import "./Services.css";

const Services = () => {
  const handleGetQuote = (category, subcategory) => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
      console.log(`Quote requested for: ${category} - ${subcategory}`);
    }
  };

  return (
    <section id="services-page" className="services-page">
      <div className="container">
        {/* Hero Section */}
        <div className="services-hero">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-gradient">{heroContent.title}</span>
            </h1>
            <p className="hero-subtitle">{heroContent.subtitle}</p>
            <div className="hero-stats">
              {heroStats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <span className="stat-number">{stat.number}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="categories-grid">
          {serviceCategories.map((category) => (
            <ServiceCategoryCard
              key={category.id}
              category={category}
              onGetQuote={handleGetQuote}
            />
          ))}
        </div>

        <CTA />
      </div>
    </section>
  );
};

export default Services;
